import { useEffect } from 'react'
import  * as echarts from 'echarts'

function useECharts(chartRef, options, loading) {
  let myChart: any

  function renderChart() {
    const chart = echarts.getInstanceByDom(chartRef.current)
    if (chart) {
      myChart = chart
      myChart.clear()
    } else {
      myChart = echarts.init(chartRef.current)
    }
    myChart && myChart.setOption(options)
  }
  // 监听窗口大小变化，重新渲染图表
  const handleResize = () => {
    if (!chartRef?.current) return
    const chart = echarts.getInstanceByDom(chartRef.current)
    chart?.resize({
      animation: { duration: 300 } // 可选动画效果
    })
  }

  useEffect(() => {
    if(chartRef?.current) {
      renderChart()
    }
    window.addEventListener('resize', handleResize);

    return () => {
      myChart && myChart.dispose()
      window.removeEventListener('resize', handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, loading])

  return
}

export default useECharts
